import api from './api';
import { setCars } from '../features/cars/carsSlice';

let loadPromise = null;

/** Fetch inventory once and cache in Redux (not on initial App mount). */
export function ensureCarsLoaded(dispatch, getState) {
  const existing = getState?.()?.cars?.items;
  if (existing?.length > 0) {
    return Promise.resolve(existing);
  }
  if (loadPromise) return loadPromise;

  loadPromise = api
    .get('/cars', { params: { limit: 1000 } })
    .then((response) => {
      if (response.data.success) {
        const cars = response.data.data.cars;
        const total = response.data.data.pagination?.total;
        if (typeof total === 'number' && cars.length > 0 && cars.length < total) {
          console.warn(
            `[MyCarSlot] Inventory partial load: received ${cars.length} of ${total} cars. Retry or check API limit.`
          );
        }
        dispatch(setCars(cars));
        return cars;
      }
      return [];
    })
    .catch((error) => {
      loadPromise = null;
      throw error;
    });

  return loadPromise;
}

export function resetCarsLoaderCache() {
  loadPromise = null;
}
